module.exports = __webpack_public_path__ + "media/handling_credit_cards/cc_feature_article_img-15e1ec6b.png";